import { gql } from '@apollo/client';

export const UPDATE_RATE_CARD = gql`
  mutation UpdateRateCard($rateCard: RateCardPatchModelInput!, $uid: String!) {
    patchRateCard(rateCard: $rateCard, uid: $uid) {
      name
      referenceId
      referenceCode
    }
  }
`;

export default UPDATE_RATE_CARD;
